var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import { StyledDialog } from '../Components/Dialog/StyledDialog';
import { WarningIcon } from '../Components/Icons';
import styles from './ClinicalDecisionSupportDialog.module.css';
import { Typography } from '@material-ui/core';
import { ClinicalDecisionSupport } from './ClinicalDecisionSupport';
import { singularisePluralise } from '../Shared/StringUtilities';
import { getClinicalDecisionData, updateCdsDetail } from '../Async/ClinicalDecisionSupportAsync';
import { ClinicalDecisionSupportLoading } from './ClinicalDecisionSupportLoading';
import { CancelledRequest, useHttpConfig } from '../Shared/HttpRequestExecutor';
import { emptyGuid } from '../Shared/Constants';
import moment from 'moment';
import { ValidDateFormats } from '../Shared/DateUtilities';
export var ClinicalDecisionSupportDialog = function (props) {
    var _a, _b, _c, _d, _e, _f, _g;
    var _h = __read(useState([]), 2), cdsDetailsList = _h[0], setCdsDetailsList = _h[1];
    var _j = __read(useState([]), 2), currentCds = _j[0], setCurrentCds = _j[1];
    var _k = __read(useState(0), 2), cdsIndex = _k[0], setCdsIndex = _k[1];
    var _l = __read(useState(true), 2), isCdsLoading = _l[0], setCdsLoading = _l[1];
    var _m = __read(useState([]), 2), medicationCodes = _m[0], setMedicationCodes = _m[1];
    var _o = __read(useState(), 2), currentMedicationCode = _o[0], setCurrentMedicationCode = _o[1];
    var httpConfig = useHttpConfig();
    var _p = __read(useState(false), 2), acceptLoading = _p[0], setAcceptLoading = _p[1];
    var handleNextMedication = function (isDeclined) {
        var _a;
        if (!isDeclined) {
            var updatePatientMedicationCds = {
                patientMedicationId: (_a = currentCds[0]) === null || _a === void 0 ? void 0 : _a.patientMedicationId,
                notedOn: moment().format(ValidDateFormats.NodeDateTimeTimezone)
            };
            updateCdsDetail(updatePatientMedicationCds).then(function (response) {
                setAcceptLoading(true);
                if (cdsIndex == medicationCodes.length - 1) {
                    props.setShowClinicalDecisionSupportDialog(false);
                    setCurrentCds([]);
                }
                else {
                    setCdsIndex(cdsIndex + 1);
                }
                props.setCdsResponse(response);
                setAcceptLoading(false);
            });
        }
        else {
            if (cdsIndex == medicationCodes.length - 1) {
                props.setShowClinicalDecisionSupportDialog(false);
                setCurrentCds([]);
            }
            else {
                setCdsIndex(cdsIndex + 1);
            }
        }
    };
    var getCdsData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, err_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getClinicalDecisionData(httpConfig, props.patient.authoringSystem, props.patient.authoringSystemForeignKey, {
                            encounter: {
                                id: emptyGuid,
                                authoringSystem: props.encounter.authoringSystem,
                                authoringSystemForeignKey: props.encounter.authoringSystemForeignKey
                            },
                            medication: props.medication ? {
                                medicationCode: (_a = props.medication) === null || _a === void 0 ? void 0 : _a.medicationCode,
                                patientMedicationId: (_b = props.medication) === null || _b === void 0 ? void 0 : _b.patientMedicationId
                            } : null
                        })];
                case 1:
                    result = _c.sent();
                    if (result instanceof CancelledRequest)
                        return [2 /*return*/];
                    setCdsDetailsList(result);
                    setCdsLoading(false);
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _c.sent();
                    setCdsLoading(false);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getCurrentCdsData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var currentCds;
        return __generator(this, function (_a) {
            currentCds = cdsDetailsList.filter(function (x) { return x.medicationCode == currentMedicationCode; });
            setCurrentCds(currentCds);
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        getCdsData();
    }, []);
    useEffect(function () {
        var medCodes = new Set(cdsDetailsList.map(function (x) { return x.medicationCode; }));
        setMedicationCodes(Array.from(medCodes));
    }, [cdsDetailsList]);
    useEffect(function () {
        setCurrentMedicationCode(medicationCodes[0]);
    }, [medicationCodes]);
    useEffect(function () {
        getCurrentCdsData();
    }, [currentMedicationCode]);
    useEffect(function () {
        setCurrentMedicationCode(medicationCodes[cdsIndex]);
    }, [cdsIndex]);
    var content = (React.createElement(ClinicalDecisionSupport, { medicationName: ((_a = currentCds[0]) === null || _a === void 0 ? void 0 : _a.medicationName) || '', medicationId: ((_b = currentCds[0]) === null || _b === void 0 ? void 0 : _b.patientMedicationId) || '', setShowClinicalDecisionSupportDialog: function (show) {
            props.setShowClinicalDecisionSupportDialog(show);
        }, cdsDetailsList: currentCds, onHandleNextMedication: function (isDeclined) {
            handleNextMedication(isDeclined);
        }, isReprescribe: props.isReprescribe, onUpdate: props.onUpdate, setIgnoreFormValidation: function (value) {
            props.setIgnoreFormValidation(value);
        }, isCdsFailed: (_c = currentCds[0]) === null || _c === void 0 ? void 0 : _c.isCdsFailed, acceptLoading: acceptLoading }));
    return (React.createElement(React.Fragment, null,
        isCdsLoading &&
            React.createElement(StyledDialog, { open: true, size: 'xs', modal: true, testId: 'cds-loading-dialog', contentComponent: React.createElement(ClinicalDecisionSupportLoading, null) }),
        (currentCds.length > 0 && !isCdsLoading) &&
            React.createElement(StyledDialog, { open: true, size: 'xs', modal: true, testId: 'cds-dialog', titleComponent: React.createElement("div", { className: ((_d = currentCds[0]) === null || _d === void 0 ? void 0 : _d.isCdsFailed) ? styles.titleFail : styles.title },
                    !((_e = currentCds[0]) === null || _e === void 0 ? void 0 : _e.isCdsFailed) && React.createElement(WarningIcon, { size: '48', color: 'white' }),
                    React.createElement("div", { className: styles.titleText },
                        React.createElement(Typography, { color: 'inherit' },
                            React.createElement("div", null, ((_f = currentCds[0]) === null || _f === void 0 ? void 0 : _f.isCdsFailed) ?
                                React.createElement("label", { className: styles.tileFontNormal },
                                    "Currently unable to determine if there are alerts for the selected ",
                                    React.createElement("br", null),
                                    " medication")
                                :
                                    React.createElement(React.Fragment, null,
                                        " ",
                                        React.createElement("label", { className: styles.tileFontNormal },
                                            currentCds.length,
                                            " ",
                                            singularisePluralise('alert', currentCds.length),
                                            " for "),
                                        React.createElement("label", { className: styles.tileFontBold }, (_g = currentCds[0]) === null || _g === void 0 ? void 0 : _g.medicationName)))))), contentComponent: content })));
};
